<!-- 数据生成设置 == 字段映射 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:"3144",
        name:"字段映射",
        parentId:"GEN_ID",
        parentName:"数据生成设置",
        parentPath:"/system/genData",
        parentQuery:{
        },
        addForm:{
        },
        dataClass:2,
        col:[]
      }'
    >
    </Table>
  </div>
</template>

<script>
import Table from '@/components/table/dataTablecSon';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>

<style></style>